module.exports = __webpack_public_path__ + "static/media/bg.3dc6eb74.jpg";